<template>
    <div id="printMe" ref="printMe1" class="printMe">
      <div>
        <div class="divCenter f28 mb10 mt20">{{form.companyName}}</div>
        <div class="dottedLine divCenter">{{form.shopName}}</div>
        <div class="align-items">
          <p>订单号：</p>
          <p>{{form.id}}</p>
        </div>
        <div class="align-items">
          <p>支付时间：</p>
          <p>{{formatDate(form.payTime)}}</p>
        </div>
        <div class="align-items">
          <p>付款方式：</p>
          <p>{{form.payWay}}</p>
        </div>
        <div v-if="form.leftAmount">
          <div class="align-items">
            <p>付款人：</p>
            <p>{{form.customerName}}</p>
          </div>
          <div class="align-items dottedLine">
            <p>会员余额：</p>
            <p>{{form.leftAmount}}元</p>
          </div>
        </div>
        <div v-else>
          <div class="align-items dottedLine">
            <p>付款人：</p>
            <p>{{form.customerName}}</p>
          </div>
        </div>
        <div class="dottedLine">
          <div v-for="item,index in form.orderItemList" :key="index">
            <div>{{item.itemName}}</div>
            <div class="align-items">
              <p>数量/价格</p>
              <p>{{item.itemNum}}</p>
              <p>{{item.realPayAmount}}</p>
            </div>
            <div class="align-items">
              <p>会员折扣</p>
              <p>{{-item.discountAmount}}</p>
            </div>
          </div>
        </div>
        <div class="align-items">
          <p>订单金额</p>
          <p>{{form.orderAmount}}</p>
        </div>
        <div class="align-items">
          <p>折扣金额</p>
          <p>{{-form.discountAmount}}</p>
        </div>
        <div class="align-items">
          <p>卡券优惠</p>
          <p>{{-form.couponAmount}}</p>
        </div>
        <div class="align-items dottedLine">
          <p>实收金额</p>
          <p>{{form.realPayAmount || 0}}元</p>
        </div>
        <div>
          <div class="printCode"><img src="../../assets/images/new/printUserCode.png" alt=""></div>
        </div>
      </div>
    </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  data () {
    return {
      isPrint: false,
      form: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$on("set", function(org) {
        this.isPrint = org.isPrint;
        if (org.orderId) {
           this.$api.get(this.$url.orderInfo.getForPrint, {id: org.orderId }).then(res => {
            if (res) {
              res.discountAmount = (Number(res.orderAmount) - Number(res.realPayAmount)).toFixed(2);
              this.form = res;
              console.log(this.form);
              this.print();
            }
          })
        }
      });
    },
    print() { // 打印
      setTimeout(() => {
        this.$print(this.$refs['printMe1'])  //打印
        this.isPrint = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>

.printMe {
  position: absolute;
  left: 999px;
  top: 999px;
  z-index: -999;
  width: 250px;
  min-width: 250px;
  background: #fff;
  div {
    width: 100%;
    min-width: 100%;
  }
}
.dottedLine {
  border-bottom: 2px dashed #000;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
.printCode {
  width: 250px;
  height: 95px;
  margin-top: 40px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>